import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../components/asyncLoadingButton/AsyncLoadingButton";

interface Props {
  open: boolean;
  offerName: string;
  onConfirm: (note: string) => Promise<void>;
  onCancel: () => void;
}

const BookOfferDialog: FC<Props> = ({ open, offerName, onConfirm, onCancel }) => {
  const [note, setNote] = useState("");

  const handleConfirm = async () => {
    await onConfirm(note);
    setNote("");
  };
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Zarezerwuj {offerName}</DialogTitle>
      <DialogContent>
        <TextField
          style={{ marginTop: "8px" }}
          label="Opisz zmiany w zamówieniu"
          fullWidth
          multiline
          minRows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" autoFocus onClick={onCancel}>
          Anuluj
        </Button>
        <AsyncLoadingButton onClick={handleConfirm}>Potwierdź</AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BookOfferDialog;
